$(function(){
  class ScrollFeatureCollection extends HTMLElement {
    constructor() {
      super();
      console.log($(this)[0])
      this._sectionId = $(this).attr('data-section-id');
      this._mobileNum = $(this).attr('data-mobile-num');
      this._pcNum = $(this).attr('data-pc-num');

      this._pcRowGap = $(this).attr('data-pc-row-gap');
      this._moblieRowGap = $(this).attr('data-mobile-row-gap');
      

      this.initSFCSwiper();
      this.initCopyClick();
    }

    initCopyClick(){
      $('.spc_product_discount').on('click',function(){
        const that = this;
        let discount_code = $(this).attr('data-code');
        navigator.clipboard.writeText(discount_code).then(()=>{
          $(this).addClass('spc_product_discount_click');
        }).catch((err)=>{
          console.log("复制失败...")
        })
        
        
        setTimeout(function(){
          $(that).removeClass('spc_product_discount_click');
        },1500)
      })
    }

    initSFCSwiper(){
      new Swiper(`.sfc_swiper_${this._sectionId}`, {
        slidesPerView: Number(this._mobileNum),
        spaceBetween: Number(this._moblieRowGap),
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          749: {
            slidesPerView: parseInt(Number(this._mobileNum)/2),
            spaceBetween: Number(this._moblieRowGap),
          },
          990: {
            slidesPerView: Number(this._pcNum),
            spaceBetween: Number(this._pcRowGap),
          }
        },
      });
  
    }
  
  
   
  }
  
  if (!customElements.get('scroll-feature-collection')) {
    customElements.define('scroll-feature-collection', ScrollFeatureCollection);
  }

})